import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, EventEmitter, forwardRef, Input, Output, TemplateRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

export interface ITag {
  title: string;
  disabled?: boolean;
}

export const TAG_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TagComponent),
  multi: true
}

@Component({
  selector: 'ad-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  providers: [TAG_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagComponent implements ControlValueAccessor {
  _tags: ITag[] = [];
  @Input()
  get tags() {
    return this._tags;
  }
  set tags(val: ITag[]) {
    this._tags = val;
    if (this.initialized) {
      this.setValue([]);
    }
  }

  @Input() mode: 'single' | 'multi' | 'mutex' = 'mutex';

  @Output() onChange: EventEmitter<ITag[]> = new EventEmitter();

  @ContentChild('tag')
  tagTemplate: TemplateRef<any>;

  value: ITag[] = [];
  onModelChange: (value: ITag[]) => void = () => { };
  onModelTouched: () => void = () => { };
  disabled: boolean = false;

  initialized: boolean = false;

  constructor(private cd: ChangeDetectorRef) {

  }
  ngAfterContentInit() {
    this.initialized = true;
  }


  isTagActive(tag) {
    if (!this.value) return false;
    return !!~this.value.indexOf(tag);
  }

  onClick(tag: ITag) {
    if (this.disabled || tag.disabled) return;
    this.setValue(this.calculateValue(tag));
  }

  setValue(value: ITag[]) {
    this.value = value;
    this.onChange.emit(this.value);
    this.onModelChange(this.value);
  }

  calculateValue(tag: ITag) {
    if (this.mode === 'mutex') {
      return [tag];
    } else if (this.mode === 'single') {
      if (!~this.value.indexOf(tag)) {
        return [tag];
      } else {
        return [];
      }
    } else {
      if (!~this.value.indexOf(tag)) {
        return [...this.value, tag];
      } else {
        return this.value.filter(it => it != tag);
      }
    }
  }

  writeValue(obj: any): void {
    if (obj == null) {
      this.value = [];
    } else {
      this.value = [...obj];
    }
    this.cd.detectChanges();
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
